import * as React from 'react';
import { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import Helmet from 'react-helmet';
import ScrollAnimation from 'react-animate-on-scroll';
import './Home.css';
import './HomePhysio.css';
import FooterStaticComponent from '../Layout/FooterStatic';

interface IState {
    IsVideoModalVisible: boolean,
}

class HomePhysioComponent extends Component<RouteComponentProps<any>, IState> {
    constructor(props) {
        super(props);

        this.state = {
            IsVideoModalVisible: false
        }
    }

    public render() {
        return (
            <div className="home-component route-component home-physio-component">
                <Helmet>
                    <meta name="title" content="Znajdź Fizjoterapeutę - wyszukiwarka fizjoterapeutów w Twojej okolicy" />
                    <meta name="description" content="Znajdź zaufanego fizjoterapeutę i umów wizytę w dogodnym terminie. Najbardziej aktualna baza fizjoterapeutów z prawem wykonywania zawodu." />
                </Helmet>

                <div className="search-wrapper">
                    <div className="home-wrapper">
                        <div className="main-container">
                            <div className="main-text-container">
                                <h1 className="main-title">Daj się znaleźć <b>nowym pacjentom</b></h1>
                                <h2 className="main-desc">Stwórz profesjonalną wizytówkę i <b>buduj swoją rozpoznawalność</b> jako fizjoterapeuta!</h2>
                                <a href="https://logowanie.kif.info.pl/register"><button className="main-cta-btn std-primary-btn">Załóż konto</button></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="static-info-component">
                    <div className="how-it-works">
                        <ScrollAnimation animateIn="fadeIn" duration={0.05} animateOnce={true}>
                            <h2 className="section-maintitle">Jak to działa?</h2>
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="fadeIn" duration={0.65} delay={150} animateOnce={true}>
                            <div className="three-sections">
                                <div className="account-step">
                                    <h3>Załóż konto</h3>
                                    <p>Zarejestruj się w naszym serwisie za&nbsp;pomocą swojego numeru PWZFz</p>
                                </div>
                                <div className="profile-step">
                                    <h3>Uzupełnij profil</h3>
                                    <p>Dodaj opis kariery, terapie i zdjęcia, aby pokazać&nbsp;się pacjentom od najlepszej strony</p>
                                </div>
                                <div className="calendar-step">
                                    <h3>Pokaż się pacjentom</h3>
                                    <p>Nowi pacjenci mogą Cię wyszukać, a&nbsp;istniejący - zapisać&nbsp;się on-line!</p>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>

                    <div className="search-info">
                        <div className="search-view-wrapper">
                            <div className="search-view">
                                <ScrollAnimation animateIn="fadeIn" duration={0.65} animateOnce={true}>
                                    <div className="info-card-container">
                                        <div className="info-card info-card-1">
                                            <span>Twórz <b>profesjonalny <br />profil</b> Twoich usług</span>
                                        </div>
                                        <div className="info-card info-card-2">
                                            <span>Prosta <b>integracja</b> <br />z aplikacją <b>Finezjo</b></span>
                                        </div>
                                        <div className="info-card info-card-3">
                                            <span><b>Powiadomienia</b> <br />o nowych wizytach</span>
                                        </div>
                                        <div className="info-card info-card-4">
                                            <span>Serwis <b>rekomendowany</b> przez <br /><b>Krajową Izbę Fizjoterapeutów</b></span>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>

                    <div className="description">
                        <div className="description-content">
                            <h2 className="section-maintitle">
                                <span className="section-subtitle">Użytkownicy</span>
                                <b>Dla kogo</b> <br />jest ten serwis?
                                </h2>
                            <p className="description-text">
                                Serwis Znajdź Fizjoterapeutę jest miejscem <b>dla wszystkich fizjoterapeutów</b>.
                                </p>
                            <p className="description-text">
                                Stwórz profesjonalna wizytówkę i buduj swoją rozpoznawalność jako fizjoterapeuta!
                                </p>
                        </div>
                        <div className="description-image">
                            <ScrollAnimation animateIn="fadeIn" duration={0.55} animateOnce={true}>
                                <div className="info-card info-card-1">
                                    <div className="info-card-content">
                                        <span>Każdy rodzaj działalności</span>
                                        <span>Własny gabinet, a może etat? <br />Nieważne, jesteśmy dla Ciebie!</span>
                                    </div>
                                </div>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.55} animateOnce={true}>
                                <div className="info-card info-card-2">
                                    <div className="info-card-content">
                                        <span>Każdy etap kariery zawodowej</span>
                                        <span>Nieważne ile lat stażu zawodowego masz za sobą - z nami się rozwiniesz!</span>
                                    </div>
                                </div>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.55} animateOnce={true}>
                                <div className="info-card info-card-3">
                                    <div className="info-card-content">
                                        <span>Wszystkie placówki</span>
                                        <span>SPA, gabinet, siłownia, a może szpital? <br />Dołącz do nas!</span>
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>

                    <div className="why-join">
                        <h2 className="section-maintitle">
                            <span className="section-subtitle">Korzyści</span>
                            Dlaczego <br /><b>warto dołączyć</b>?
                        </h2>
                        <ScrollAnimation animateIn="fadeIn" duration={0.65} animateOnce={true}>
                            <div className="three-sections">
                                <div className="section">
                                    <h3>Zyskasz nowych klientów</h3>
                                    <p>Zwiększysz szanse na pozyskanie nowych klientów</p>
                                </div>
                                <div className="section">
                                    <h3>Zbudujesz wizerunek</h3>
                                    <p>Wzmocnisz swój wizerunek jako profesjonalisty medycznego</p>
                                </div>
                                <div className="section">
                                    <h3>Zyskasz darmową reklamę</h3>
                                    <p>Zaprezentujesz swoje usługi oraz umiejętności - bez żadnych opłat</p>
                                </div>
                                <div className="section">
                                    <h3>Umożliwisz zapisy on-line</h3>
                                    <p>Zyskasz darmowe narzędzie do zarządzania zapisami online</p>
                                </div>
                                <div className="section">
                                    <h3>Zautomatyzujesz terminarz</h3>
                                    <p>Zautomatyzujesz system powiadomień o wizytach oraz wszelkich zmianach w terminach</p>
                                </div>
                                <div className="section">
                                    <h3>Zintegrujesz się z Finezjo</h3>
                                    <p>Korzystasz z Finezjo jako praktyka jednoosobowa? Połącz konta!</p>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>

                    <div className="about-us">
                        <div className="about-us-content">
                            <div className="about-us-line">
                                <h2 className="section-maintitle about-us-point">
                                    <span className="section-subtitle">O nas</span>
                                    <b>Poznaj serwis</b> <br />Znajdź Fizjoterapeutę
                                    </h2>
                                <div className="about-us-point">
                                    <ScrollAnimation animateIn="fadeIn" duration={0.65} animateOnce={true}>
                                        <span className="about-us-number">01</span>
                                        <h3 className="about-us-title">Dlaczego my?</h3>
                                        <p className="about-us-text"><b>Unikatowość Znajdź Fizjoterapeutę</b> na tle innych wyszukiwarek specjalistów medycznych polega na dostosowaniu serwisu do potrzeb rynku usług fizjoterapeutycznych.</p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                            <div className="about-us-line">
                                <div className="about-us-point">
                                    <ScrollAnimation animateIn="fadeIn" duration={0.65} delay={150} animateOnce={true}>
                                        <span className="about-us-number">02</span>
                                        <h3 className="about-us-title">Możliwości</h3>
                                        <p className="about-us-text">W serwisie oprócz możliwości wyszukania specjalistów po lokalizacji, istnieje także opcja <b>znalezienia fizjoterapeutów</b> ukierunkowanych na leczenie konkretnych przypadłości oraz stosujących dane metody terapii.</p>
                                    </ScrollAnimation>
                                </div>
                                <div className="about-us-point">
                                    <ScrollAnimation animateIn="fadeIn" duration={0.65} delay={300} animateOnce={true}>
                                        <span className="about-us-number">03</span>
                                        <h3 className="about-us-title">Funkcje</h3>
                                        <p className="about-us-text">Znajdź Fizjoterapeutę jest serwisem łączącym fizjoterapeutów z osobami szukającymi usług fizjoterapeutycznych. Jego podstawowe funkcje to <b>wyszukiwanie specjalistów</b> poprzez wybrane kryteria oraz <b>umawianie wizyt online</b>.</p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="instruction">
                        <div className="instruction-image" onClick={this.OnVideoOpen}>
                            <div className="instruction-image-text">
                                Obejrzyj instrukcję!
                            </div>
                        </div>
                        <div className="instruction-content">
                            <h2 className="section-maintitle">
                                <span className="section-subtitle">Instrukcja</span>
                                <b>Stwórz swój profil</b> w&nbsp;kilku prostych krokach
                                </h2>
                            <ScrollAnimation animateIn="fadeIn" duration={0.55} animateOnce={true}>
                                <p className="instruction-text">
                                    Obejrzyj krótki film instruktażowy jak dołączyć do serwisu i&nbsp;utworzyć profesjonalną wizytówkę swoich usług.
                                </p>
                                <p className="instruction-link" onClick={this.OnVideoOpen}>
                                    Obejrzyj instrukcję
                                </p>
                            </ScrollAnimation>
                        </div>
                        {this.state.IsVideoModalVisible &&
                            <div className="instruction-video-container" onClick={this.OnVideoClose}>
                                <div className="instruction-video-wrapper">
                                    <div className="instruction-video" onClick={this.OnModalPanelClick}>
                                        <iframe
                                            width="560"
                                            height="315"
                                            src="https://www.youtube.com/embed/17i_Q4p7Kmg?modestbranding=&rel=0&autoplay=1"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <div className="contact">
                        <h2 className="section-maintitle">
                            <span className="section-subtitle">Kontakt</span>
                            <b>Masz do nas pytania?</b><br />Pomożemy!
                        </h2>
                        <p className="contact-text">
                            Masz pytania, uwagi lub sugestie? Skontaktuj się z nami i porozmawiajmy!
                        </p>
                        <button onClick={this.RedirectToContact} className="contact-btn std-primary-btn">
                            Napisz do nas
                        </button>
                    </div>
                </div>

                <FooterStaticComponent />
            </div>
        );
    }

    private RedirectToContact = () => {
        this.props.history.push('/contact');
    }

    private OnModalPanelClick = e => {
        e.stopPropagation();
    };

    private OnVideoOpen = () => {
        this.setState({
            IsVideoModalVisible: true
        });
    }

    private OnVideoClose = () => {
        this.setState({
            IsVideoModalVisible: false
        });
    }
}

export default withRouter(HomePhysioComponent);



// WEBPACK FOOTER //
// ./src/components/Home/HomePhysio.tsx